import { Box, Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import MaterialTable from "material-table";
import moment from "moment";
import LabelsContext from "../../../lang/LabelsContext";
import EnumDesignation from "../../../utils/enum/EnumDesignation";
import DialogTitle from "../dialog-title/DialogTitle";
import { tableIcons } from "../material-table-utils/MaterialTableUtils";
import useStyles from "./OriginalFilesStyle";
import { FILTER_LAST, useOriginalFiles } from "./useOriginalFiles";

interface IOriginalFiles {
  files: any;
  visible: boolean;
  close: () => void;
}

export default function OriginalFiles({ files, visible, close }: IOriginalFiles) {
  const { Labels } = LabelsContext();
  const classes = useStyles();
  const {
    filesFilter,
    revisionOption,
    revisionSelectedOption,
    setRevisionSelectedOption,
    filesToogle,
    setFilesToogle,
  } = useOriginalFiles({
    files,
    visible,
  });
  return (
    <Dialog maxWidth="lg" fullWidth={true} open={visible} onClose={close} aria-labelledby="form-dialog-title">
      <DialogTitle onClose={close}>Original files</DialogTitle>
      <DialogContent>
        <MaterialTable
          icons={tableIcons}
          columns={[
            {
              field: "filename",
              sorting: true,
              title: Labels.FILE_NAME,
              render: (rowData: any) => (
                <div>
                  <Link href={rowData.location} color="inherit" component="a" target="_blank">
                    {rowData.filename}
                    {rowData.type === EnumDesignation.OVERVIEW && <ListAltIcon color="action" />}
                  </Link>
                </div>
              ),
            },
            { field: "revision", title: Labels.REVISION, defaultSort: "desc" },
            { field: "type", title: Labels.TYPE },
            { field: "fileType", title: Labels.FILE_TYPE },
            {
              field: "uploadDate",
              title: "Upload date",
              defaultSort: "desc",
              render: (rowData: any) => <div>{moment(rowData.uploadDate).format("YYYY-MM-DD HH:mm:ss")}</div>,
            },
          ]}
          title=""
          data={filesFilter}
          options={{
            actionsColumnIndex: -1,
            pageSize: 10,
            searchFieldAlignment: "left",
            searchFieldStyle: {
              marginTop: "12px",
            },
          }}
          components={{
            Action: (props) => (
              <Box flex flexDirection="row" className={classes.box}>
                <Autocomplete
                  className={classes.revision}
                  value={revisionSelectedOption}
                  onChange={(event, newValue) => {
                    if (newValue?.id === -1) {
                      setFilesToogle(FILTER_LAST);
                    }
                    setRevisionSelectedOption(newValue);
                  }}
                  options={revisionOption}
                  getOptionLabel={(option: any) => option.name}
                  filterSelectedOptions
                  renderInput={(params: any) => <TextField {...params} variant="outlined" label={Labels.REVISION} />}
                />
                <ToggleButtonGroup
                  value={filesToogle}
                  onChange={(item, value: string) => setFilesToogle(value)}
                  exclusive
                  aria-label="text alignment"
                >
                  <ToggleButton value="all" aria-label="left aligned" disabled={revisionSelectedOption?.id === -1}>
                    All
                  </ToggleButton>
                  <ToggleButton value="last" aria-label="centered">
                    Last
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            ),
          }}
          actions={[
            {
              icon: () => <AddCircleIcon color="action" />,
              position: "toolbar",
              onClick: (event, rowData) => alert("something"),
              isFreeAction: true,
            },
          ]}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="contained" color="primary">
          {Labels.CANCEL}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
